import React from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { QrCodeScan, Gear, Person, Bell, Box } from "react-bootstrap-icons";
import { Link } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";

const NavbarBottom = () => {
  return (
    <div className="bottom-menu fixed-bottom bg-light border-top pt-3 pb-2">
      <Container fluid>
        <Row className="text-center">
          <Col>
            <Nav.Link as={Link} to="/dashboard">
              <QrCodeScan size={20} />
              <div className="mt-1">
                <small>Skan</small>
              </div>
            </Nav.Link>
          </Col>
          <Col>
            <Nav.Link as={Link} to="/devices">
              <Gear size={20} />
              <div className="mt-1">
                <small>Wyposażenie</small>
              </div>
            </Nav.Link>
          </Col>
          <Col>
            <Nav.Link as={Link} to="/users">
              <Person size={20} />
              <div className="mt-1">
                <small>Prac.</small>
              </div>
            </Nav.Link>
          </Col>
          <Col>
            <Nav.Link as={Link} to="/magazyn-stali">
              <Box size={20} />
              <div className="mt-1">
                <small>Stal</small>
              </div>
            </Nav.Link>
          </Col>
          <Col>
            <Nav.Link as={Link} to="/notification">
              <Bell size={20} />
              <div className="mt-1">
                <small>Powiad.</small>
              </div>
            </Nav.Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NavbarBottom;
